import React from 'react';
import PasswordInput from '../../components/PasswordInput';
import { Form } from '@ant-design/compatible';
import { Input, Button, Modal, Row, Col } from 'antd';
import srcFleetclearLogo from '../../assets/images/fleetclear-logo.svg';
import { Email } from '@carbon/icons-react';
import Spinner from '../Spinner';

import './loginForm.css';

const FormItem = Form.Item;

export default function () {
    const { form, isLoggingIn } = this.props;
    const { passwordResetEmail } = this.state;
    const { getFieldDecorator } = form;

    return (
        <Spinner loading={isLoggingIn}>
            <div className="loginform-wrap">
                <div className="loginform-container" style={{ padding: '0 16px', marginTop: '-16px' }}>
                    <Row>
                        <Col xs={0} sm={0} md={0} lg={0} xl={24}>
                            <div style={{ height: '56px' }} />
                        </Col>
                    </Row>
                    <div className="d-flex dir-column align-center text-center">
                        <img
                            src={srcFleetclearLogo}
                            className="login__logo-fleet"
                            alt="Fleetclear"
                            style={{ width: '80%' }}
                        />
                        <br />
                        <Row>
                            <Col xs={0} sm={0} md={0} lg={0} xl={24}>
                                <br />
                            </Col>
                        </Row>
                    </div>
                    <Form 
                        onSubmit={this.handleSubmit} 
                        layout="vertical"
                    >
                        <FormItem>
                            {getFieldDecorator('email', {
                                rules: [
                                    {
                                        type: 'email',
                                        message: 'Please enter a valid Email',
                                    },
                                    {
                                        required: true,
                                        message: 'Please input your E-mail!',
                                    },
                                ],
                            })(
                                <Input 
                                    placeholder="Enter Email" 
                                    className='login-email' 
                                />
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please input your password!',
                                    },
                                ],
                            })(
                                <PasswordInput 
                                    placeholder="Enter Password" 
                                    className="login-password" 
                                />
                            )}
                        </FormItem>
                        <div style={{ marginTop: '-10px' }}>
                            <a
                                href='#'
                                onClick={() => this.setIsVisiblePasswordResetModal(true)}
                            >
                                Forgotten password?
                            </a>
                        </div>
                        <Button
                            style={{ width: '70%' }}
                            htmlType="submit"
                            type='primary'
                            id='login-btn'
                        >
                            Login
                        </Button>
                    </Form>
                    <div className="d-flex dir-column align-center text-center">
                        <h3 className="login__heading">New to Fleetclear?</h3>
                        <a href="https://fleetclear.com/contact-us/">
                            <span className="login__contact-us">
                                <span className="login__contact-us-icon">
                                    <Email size={36} />
                                </span>
                                <a>Contact us</a>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <Modal
                centered
                width={540}
                footer={null}
                open={this.state.isVisiblePasswordResetModal}
                onOk={() => this.setIsVisiblePasswordResetModal(false)}
                onCancel={() => this.setIsVisiblePasswordResetModal(false)}
            >
                <h4 className="h-3 text-center">Password Reset Request</h4>
                <br />
                <Input 
                    placeholder="Your Registered Email" 
                    onChange={this.setPasswordResetEmail}
                    value={passwordResetEmail}
                />
                <br />
                <br />
                <Button 
                    type="primary" 
                    className="wide center-align"
                    onClick={this.sendPasswordResetEmail}
                >
                    Send Email
                </Button>
            </Modal>
        </Spinner>
    );
}
